/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Day_LeadInputs */

const en_mk_sol_day_lead = /** @type {(inputs: Mk_Sol_Day_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four moments in sequence over a single day — no grand promises, just the order in which things actually happen once agents share the work.`)
};

const id_mk_sol_day_lead = /** @type {(inputs: Mk_Sol_Day_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat momen berurutan dalam satu hari — bukan janji besar, hanya urutan yang benar-benar terjadi ketika agen ikut mengerjakan.`)
};

/**
* | output |
* | --- |
* | "Four moments in sequence over a single day — no grand promises, just the order in which things actually happen once agents share the work." |
*
* @param {Mk_Sol_Day_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_day_lead = /** @type {((inputs?: Mk_Sol_Day_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Day_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_day_lead(inputs)
	return en_mk_sol_day_lead(inputs)
});